import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';
import { assertNever } from 'owa-assert';
import { createShareableFolderModelForOneDriveItem } from './typeConverters';
import { FolderModel, ShareableFolderModel } from '../store/schema/FolderModel';
import { FolderSelectorProviderType } from '../store/schema/FolderSelectorProviderType';
import { getOneDriveItems, OneDriveItemFilterType } from 'owa-fileprovider-services';
import { HTTPResponseError } from '../types/HTTPResponseError';

export function getFoldersForProvider(
    providerType: AttachmentDataProviderType.OneDrivePro,
    endpointUrl: string,
    folderId?: string
): Promise<ShareableFolderModel[]>;
export async function getFoldersForProvider(
    providerType: FolderSelectorProviderType,
    endpointUrl: string,
    folderId?: string
): Promise<FolderModel[]> {
    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            return await getFoldersForOneDrivePro(endpointUrl, folderId);
        default:
            return assertNever(providerType);
    }
}

async function getFoldersForOneDrivePro(
    endpointUrl: string,
    folderId?: string
): Promise<ShareableFolderModel[]> {
    const {
        errorResponse,
        result: { items },
    } = await getOneDriveItems(
        endpointUrl,
        AttachmentDataProviderType.OneDrivePro,
        AttachmentItemsSortColumn.Name,
        AttachmentItemsSortOrder.Ascending,
        folderId,
        OneDriveItemFilterType.Folder
    );

    if (errorResponse) {
        throw new HTTPResponseError('Unable to fetch folders', errorResponse);
    } else {
        return items.map(item => {
            return createShareableFolderModelForOneDriveItem(
                item,
                AttachmentDataProviderType.OneDrivePro
            );
        });
    }
}
